<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <button type="button" id="btnOk" class="btn btn-primary btn-xs" @click="Save">
          <font-awesome-icon :icon="['far', 'check']" />
          {{ translation(4911) }}
        </button>
        <button type="button" id="btnCancel" class="btn btn-primary btn-xs" @click="Cancel">
          <font-awesome-icon icon="times" />
          {{ translation(4910) }}
        </button>
      </template>
    </XVactionbar>

    <XVvalidationMessage></XVvalidationMessage>

    <div id="pnlTitleBar" class="margin20">
      <span id="lblTitel" class="titel">{{ translation(4909) }}</span>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p>
          <span id="lblBeschrijving">{{ translation(4912) }}</span>
          <span id="lblBeschrijvingGegevensBeheerder">{{ translation(4922) }}</span>
        </p>
      </div>
    </div>
    <div id="pnlSelection" v-if="settings.createAccountSetting === 0">
      <div class="row">
        <div
          class="col-md-8 form-group has-feedback"
          v-bind:class="{ 'form-group--error': errors.has('rbPersonSelection') }"
        >
          <p>
            <span id="lblPersonSelection">{{ translation(5377) }}</span>
            <span>{{ errors.first('lblPersonSelection') }}</span>
          </p>
          <XVradiobuttonlist
            id="rbPersonSelection"
            :datalist="personSelectionOptions"
            :value="selectedPersonOption"
            @input="setSelectedPersonOption"
            v-validate="'required'"
            name="rbPersonSelection"
            :data-vv-as="translation(5377)"
          >
            <XVhelpcontrol slot="afterLabel" slot-scope="props" :helptext="props.item.helpText"></XVhelpcontrol>
          </XVradiobuttonlist>
          <span class="form-group__message" style="color: Red">{{ errors.first('rbPersonSelection') }}</span>
        </div>
      </div>
    </div>
    <div id="pnlExcistingPerson" v-if="selectedPersonOption === 'rdExcistingPerson'">
      <div class="row margin20">
        <div class="col-md-12">
          <fieldset>
            <legend>
              <span id="lblBestaandAccount">{{ translation(7679) }}</span>
              <a name="existingAccount"></a>
            </legend>
            <XVbootstraprow
              :label="translation(4926)"
              :helptext="translation(5378)"
              :haserror="errors.has('TblPersonUsernameExcistingAccount')"
              :errormessage="errors.first('TblPersonUsernameExcistingAccount')"
              :required="true"
            >
              <XVinput
                id="TblPersonUsernameExcistingAccount"
                name="TblPersonUsernameExcistingAccount"
                key="TblPersonUsernameExcistingAccount"
                v-model.trim="person.tblPersonUsername"
                v-validate="'required'"
                :data-vv-as="translation(4926)"
              ></XVinput>
            </XVbootstraprow>
            <XVbootstraprow
              :label="translation(4927)"
              :helptext="translation(5379)"
              :haserror="errors.has('TblPersonPasswordExcistingAccount')"
              :errormessage="errors.first('TblPersonPasswordExcistingAccount')"
              :required="true"
            >
              <XVinput
                id="TblPersonPasswordExcistingAccount"
                name="TblPersonPasswordExcistingAccount"
                key="TblPersonPasswordExcistingAccount"
                type="password"
                v-model.trim="person.tblPersonPassword"
                v-validate="'required'"
                :data-vv-as="translation(4927)"
              ></XVinput>
            </XVbootstraprow>
          </fieldset>
        </div>
      </div>
    </div>
    <div id="pnlNewPerson" v-if="selectedPersonOption === 'rdNewPerson'">
      <div class="row margin20">
        <div class="col-md-12">
          <fieldset>
            <legend>
              <span id="lblNieuwAccount">{{ translation(7678) }}</span>
              <a name="newAccount"></a>
            </legend>
            <XVbootstraprow
              :label="translation(4923)"
              :helptext="translation(4937)"
              :haserror="errors.has('TblPersonName')"
              :errormessage="errors.first('TblPersonName')"
              :required="true"
              veldID="TblPersonName"
            >
              <XVinput
                id="TblPersonName"
                name="TblPersonName"
                key="TblPersonName"
                v-model.trim="person.tblPersonName"
                v-validate="'required|max:100'"
                :data-vv-as="translation(4923)"
              ></XVinput>
            </XVbootstraprow>
            <XVbootstraprow
              :label="translation(4924)"
              :helptext="translation(4937)"
              :haserror="errors.has('TblPersonEmail')"
              :errormessage="errors.first('TblPersonEmail')"
              :required="true"
            >
              <XVinput
                id="TblPersonEmail"
                name="TblPersonEmail"
                key="TblPersonEmail"
                ref="TblPersonEmail"
                v-model.trim="person.tblPersonEmail"
                v-validate="'required|email|max:100'"
                data-vv-validate-on="blur"
                :data-vv-as="translation(4924)"
              ></XVinput>
            </XVbootstraprow>
            <XVbootstraprow
              :label="translation(4925)"
              :helptext="translation(4939)"
              :haserror="errors.has('TblPersonEmailRepeat')"
              :errormessage="errors.first('TblPersonEmailRepeat')"
              :required="true"
            >
              <XVinput
                id="TblPersonEmailRepeat"
                name="TblPersonEmailRepeat"
                key="TblPersonEmailRepeat"
                v-model.trim="person.tblPersonEmailRepeat"
                v-validate="'required|confirmed:TblPersonEmail'"
                data-vv-validate-on="blur"
                :data-vv-as="translation(4925)"
              ></XVinput>
            </XVbootstraprow>
            <XVbootstraprow
              :label="translation(4926)"
              :helptext="translation(4942)"
              :haserror="errors.has('TblPersonUsername')"
              :errormessage="errors.first('TblPersonUsername')"
              :required="true"
            >
              <XVinput
                id="TblPersonUsername"
                name="TblPersonUsername"
                key="TblPersonUsername"
                v-model.trim="person.tblPersonUsername"
                v-validate="SchemaCheckUsername()"
                data-vv-validate-on="blur"
                :data-vv-as="translation(4926)"
              ></XVinput>
            </XVbootstraprow>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="row margin20">
      <div class="col-md-12">
        <fieldset>
          <legend>
            <span id="lblExtOrgAccount">{{ translation(7680) }}</span>
            <a name="extOrgAccount"></a>
          </legend>
          <extOrgDetailsForm v-model="extOrg" :profgroupID="profgroupID" />
        </fieldset>
        <XVMetaDataBlock
          class="margin20"
          name="XVMetaDataBlock"
          infoRequiredName="TblExternalOrganizationInfoRequired"
          :postData="MetadataPostData"
          :legendText="translation(7681)"
        ></XVMetaDataBlock>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { FAMixin, util } from 'pevueglobal'
import { sync } from 'vuex-pathify'
import extOrgDetailsForm from './ExtOrgDetailsForm'

export default {
  mixins: [FAMixin],
  components: {
    extOrgDetailsForm,
  },
  data: () => ({
    profgroupID: null,
  }),
  computed: {
    ...mapGetters('SPE620ExtOrgAccountAanvragen', ['settings', 'selectedPersonOption', 'person']),
    extOrg: sync('SPE620ExtOrgAccountAanvragen/extOrg'),
    MetadataPostData() {
      return {
        SES_bergrpid: this.$route.params.profgroupID,
      }
    },
    personSelectionOptions() {
      return [
        { value: 'rdExcistingPerson', labelText: this.translation(5373), helpText: this.translation(5375) },
        { value: 'rdNewPerson', labelText: this.translation(5374), helpText: this.translation(5376) },
      ]
    },
  },
  async mounted() {
    this.getTexten()
    // this.$router.go()
    this.profgroupID = Number.parseInt(this.$route.params.profgroupID, 10)
    await this.initSettings(this.profgroupID)
  },
  methods: {
    ...mapActions('SPE620ExtOrgAccountAanvragen', ['initSettings', 'createExtOrg', 'getTexten']),
    ...mapMutations('SPE620ExtOrgAccountAanvragen', ['setSelectedPersonOption']),
    SchemaCheckUsername() {
      return {
        required: true,
        regex: /^[\S]*$/,
        customServerValidate: {
          validatorApiRoute: 'public/PEapi_CheckUsernameIsUnique/',
        },
      }
    },
    Cancel() {
      this.$router.push({
        name: 'SPE610ExtOrgSelection',
        params: { profgroupID: this.profgroupID },
      })
      // window.location = '/peapp/public/SPE610ExtOrgSelection/' + this.profgroupID
    },
    async Save() {
      const isForExistingPerson = this.selectedPersonOption === 'rdExcistingPerson'

      const promises = [this.XVvalidate()]
      if (isForExistingPerson) {
        promises.push(
          util.getDataApi('public/PEapi_CheckPersonCredentials', this.person).then((data) => data.ds.data0[0].personID)
        )
      }

      const [, tblPersonID] = await Promise.all(promises)
      if (isForExistingPerson && !tblPersonID) {
        this.errors.add({ field: 'TblPersonUsernameExcistingAccount', msg: this.translation(4) })
      }

      if (!this.errors.any()) {
        await this.createExtOrg({ tblPersonID, profgroupID: this.profgroupID })
      }
    },
  },
}
</script>
